/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  BuilderUserContext, FormRootSchema,
  FormState, FormStateSchema,
  whenCreateOrEditMode,
} from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';
import { FormMode } from '@gh/core-ui';
import { SystemVariablesContactsDetails } from '../../resources/model/system-vars-contacts-details.model';

@Injectable()
export class SystemVarsContactsTabFormState extends FormState<SystemVariablesContactsDetails> {
  constructor(private userContext: BuilderUserContext,
              schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);
  }

  protected buildSchema(value: SystemVariablesContactsDetails, { root }: FormStateSchema): FormRootSchema {
    const mode = this.userContext.hasPermission(BuilderPermission.Setup.SystemVariables.Contacts.EDIT) ?
      FormMode.EditMode : FormMode.ViewMode;

    return root({
      enabled: whenCreateOrEditMode(),
      mode,
      optimisticLock: true,
      children: {
        onNotEnteredForContact: { required: true },
        defaultDeliveryToEmail: void 0,
      },
    });
  }
}
